import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Sparkles, ArrowRight } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-gray-300 relative overflow-hidden">
      {/* Effets de fond */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-blue-600/10 to-cyan-600/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-br from-orange-600/10 to-pink-600/10 rounded-full blur-3xl" />
      
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* À propos */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-cyan-600 flex items-center justify-center shadow-lg">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <h3 className="text-white text-lg font-bold">Richard SAAD</h3>
            </div>
            <p className="text-sm mb-4 text-gray-400">
              Consultant informatique indépendant spécialisé dans l'accompagnement des TPE et PME de la région lyonnaise.
            </p>
            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600/20 to-cyan-600/20 flex items-center justify-center group-hover:from-blue-600 group-hover:to-cyan-600 transition-all">
                  <MapPin className="w-4 h-4 text-blue-400 group-hover:text-white transition-colors" />
                </div>
                <span className="group-hover:text-white transition-colors">Lyon et sa région</span>
              </div>
              <div className="flex items-center space-x-3 group">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-orange-600/20 to-pink-600/20 flex items-center justify-center group-hover:from-orange-600 group-hover:to-pink-600 transition-all">
                  <Mail className="w-4 h-4 text-orange-400 group-hover:text-white transition-colors" />
                </div>
                <a href="mailto:richard@saad-informatique.fr" className="hover:text-white transition-colors break-all">
                  richard@saad-informatique.fr
                </a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2 text-sm">
              {[
                { name: 'Accueil', path: '/' },
                { name: 'Services', path: '/services' },
                { name: 'Méthode de travail', path: '/methode' },
                { name: 'Réalisations', path: '/realisations' },
                { name: 'À propos', path: '/a-propos' },
                { name: 'Contact', path: '/contact' }
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className="hover:text-white transition-colors inline-flex items-center group"
                  >
                    <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all" />
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Informations légales</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/mentions-legales" 
                  className="hover:text-white transition-colors inline-flex items-center group"
                >
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all" />
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link 
                  to="/confidentialite" 
                  className="hover:text-white transition-colors inline-flex items-center group"
                >
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all" />
                  Confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} <span className="text-white font-semibold">Richard SAAD</span> - Consultant Informatique. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};
